import axios from 'axios';
import filter from 'lodash/fp/filter';
import get from 'lodash/fp/get';
import fetchSelf from './fetchSelf';

axios.defaults.withCredentials = true;

const updateSelf = async (data) => {
  const { uuid, endpoint } = await fetchSelf();
  const { data: token } = await axios.get('/session/token');
  const patchOptions = {
    headers: {
      'Content-Type': 'application/vnd.api+json',
      'X-CSRF-Token': token,
      Accept: 'application/vnd.api+json',
    },
  };
  if (window.location.pathname.match(/\d+/)) {
    const [step] = window.location.pathname.match(/\d+/).map(Number);
    if (data.attributes) {
      data.attributes[`field_step_${step}_finished`] = true;
    } else {
      data.attributes = {
        [`field_step_${step}_finished`]: true,
      };
    }
  }
  const patchData = {
    data: {
      type: 'user--user',
      id: uuid,
      ...data,
    },
  };
  if (patchData.data.relationships.field_favorites) {
    const favorites = patchData.data.relationships.field_favorites.data;
    patchData.data.relationships.field_favorites.data = filter(
      (item) => item.id !== 'missing',
      favorites,
    );
    console.log(patchData);
  }
  try {
    const { data: response } = await axios.patch(endpoint, patchData, patchOptions);
    return response;
  } catch (error) {
    console.error(get('response.data.errors.0.detail', error));
    return get('response.data.errors.0.detail', error);
  }
};

export default updateSelf;
